import * as Record$dUnsafe$dUnion from "../Record.Unsafe.Union/index.js";
const fromDefaults1 = () => () => ({fromDefaults: b => a => Record$dUnsafe$dUnion.unsafeUnionFn(a, b)});
const mkNamedParamsFn = () => () => defaults => impl => params => impl(Record$dUnsafe$dUnion.unsafeUnionFn(params, defaults));
const fromDefaults = dict => dict.fromDefaults;
export {fromDefaults, fromDefaults1, mkNamedParamsFn};
